import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_FAC028_Request,
  IAPI_FAC028_Response,
} from "../../../type/apiType";

// 施設等新設届一括更新
const httpAPI_FAC028 = async (
  param: IAPI_FAC028_Request
): Promise<IAPI_FAC028_Response> => {
  let res = await http.post(ApiUrl.API_FAC028, {
    ...param,
  });

  return res.data;
};

export { httpAPI_FAC028 };
